import { boolean, type } from 'superstruct';
import {
    createPersistMigrate,
    createPersistPlugin,
    createStore,
    type PayloadAction,
} from '@direct-frontend/modules-store';
import { localStorageAdapter } from '#shared/lib/persist';

type PersistentStateV1 = {
    isAltyConsent: boolean;
};

// Создаем стор
const store = createStore('widgets/AIAssistant', { plugins: [createPersistPlugin()] });

// Создаем слайс, который будет персистить часть своих данных.
export const consentSlice = store.createPersistentSlice({
    name: 'consent',
    initialState: {
        persistentData: {
            isAltyConsent: false,
        },
    },
    reducers: {
        setIsAltyConsent(state, action: PayloadAction<boolean>) {
            state.persistentData.isAltyConsent = action.payload;
        },
    },
    persist: {
        storage: localStorageAdapter,
        migration: createPersistMigrate<PersistentStateV1>(),
        validation: type({
            isAltyConsent: boolean(),
        }),
    },
});
